export const getCurrentEnvironment = () => {
  // Normalize 'prod' → 'production' to match Contentful pgDataLayerCollection environment field
  const env = process.env.ENV || "development";
  return env === "prod" ? "production" : env;
};
